import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-housing-rental-form',
  templateUrl: './housing-rental-form.component.html',
  styleUrls: ['./housing-rental-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class HousingRentalFormComponent extends LeadFormBase {
  @Input()
  formGroup!: FormGroup;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: this.fb.control(InsuranceType.HOUSING_RENTAL),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    this.formGroup.addControl('metadata', this.metadataFormGroup);
  }
}
